export { default } from "./SkeletonAddressesList-component";
